import { colors, spacing } from '@chegg-ui/theme';
import styled from 'styled-components';
import { styledSpacing } from './root'; // Some hardcoded values for calculation of scrollTop height of a mobile center nav element

var hamburgerMenuContainerTopPadding = 16;
var hamburgerMenuHeaderHeight = 42;
var mobileCenterNavItemHeight = 48;
/* istanbul ignore next */

export var getScrollTop = function getScrollTop(index) {
  return hamburgerMenuContainerTopPadding + hamburgerMenuHeaderHeight + mobileCenterNavItemHeight * index;
};
export var HamburgerMenuContainer = styled.div.withConfig({
  componentId: "iaaxk2-0"
})(["box-sizing:border-box;position:fixed;top:0;left:", ";visibility:", ";height:100vh;width:17.875rem;background:", ";transition:", ";padding:", " ", " ", " ", ";z-index:2;display:flex;flex-direction:column;overflow-y:scroll;"], function (props) {
  return props.isOpen ? '0' : '-100%';
}, function (props) {
  return props.isOpen ? 'visible' : 'hidden';
}, colors.white, function (props) {
  return props.isOpen ? 'left 0.5s, visibility ease-out' : 'left 0.5s, visibility 0.5s ease-out';
}, styledSpacing.px16, styledSpacing.px16, styledSpacing.px16, styledSpacing.px44);
export var ScreenBlocker = styled.div.withConfig({
  componentId: "iaaxk2-1"
})(["width:100vw;height:100vh;visibility:", ";opacity:0.7;position:fixed;top:0;left:0;background-color:", ";z-index:1;transition:visibility 0.5s ease-out;"], function (props) {
  return props.isActive ? 'visible' : 'hidden';
}, colors.greyMedium);
export var HamburgerMenuHead = styled.div.withConfig({
  componentId: "iaaxk2-2"
})(["box-sizing:border-box;display:flex;justify-content:space-between;align-items:center;margin-bottom:", ";"], styledSpacing.px12);
export var CenterNavList = styled.ul.withConfig({
  componentId: "iaaxk2-3"
})(["display:flex;flex-direction:column;list-style:none;margin:0;padding:0;"]);
export var CenterNavListItem = styled.li.withConfig({
  componentId: "iaaxk2-4"
})(["position:relative;&::before{content:'';display:", ";position:absolute;width:0.25rem;height:1.25rem;left:", ";top:", ";background-color:", ";}"], function (props) {
  return props.isActive ? 'block' : 'none';
},
/* istanbul ignore next */
function (props) {
  return props.positionX && props.positionX < 0 ? "calc(-100vw + ".concat(Math.abs(props.positionX), "px)") : "-".concat(props.positionX, "px");
}, spacing.px12, colors.cheggOrange);